import { Component, EventEmitter, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'ribbon-for-email-verification',
  standalone: true,
  imports: [],
  templateUrl: './ribbon-for-email-verification.component.html',
  styleUrl: './ribbon-for-email-verification.component.scss',
})
export class RibbonForEmailVerificationComponent {
  @Output() onEmailChangeClick = new EventEmitter<void>();

  constructor(
    public authService: AuthService,
    private _matSnackbar: MatSnackBar
  ) {}

  async resendVerification() {
    try {
      await this.authService.sendEmailVerification();
      this._matSnackbar.open('Verification email sent');
    } catch (e: any) {
      this._matSnackbar.open('Unexpected error' + e.toString());
    }
  }
}
